import { Toaster } from 'react-hot-toast';

export default function Toast() {
  return (
    <Toaster
      position="bottom-right"
      toastOptions={{
        duration: 4000,
        style: {
          background: 'var(--toast-background)',
          color: 'var(--toast-color)',
          borderRadius: '0.75rem',
          padding: '0.75rem 1rem',
          border: '1px solid rgba(0, 0, 0, 0.05)',
          boxShadow: '0 8px 16px -4px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
          fontSize: '0.875rem',
          fontWeight: '500',
        },
        success: {
          style: {
            backgroundColor: '#F0FDF4',
            color: '#166534',
            border: '1px solid #DCFCE7',
          },
          iconTheme: {
            primary: '#22C55E',
            secondary: '#F0FDF4',
          },
        },
        error: {
          style: {
            backgroundColor: '#FEF2F2',
            color: '#991B1B',
            border: '1px solid #FEE2E2',
          },
          iconTheme: {
            primary: '#EF4444', 
            secondary: '#FEF2F2',
          },
        },
      }}
    />
  );
}